import AppIdb from '../../data/app-idb';
import CONFIG from '../../global/config';
import AyahToolInitiator from '../../utils/ayah-tool/ayah-tool-initiator';
import {
  createLoadingTemplate,
  createContentEmptyTemplate,
  createAyahTemplate,
} from '../templates/template-creator';

class Favorite extends HTMLElement {
  connectedCallback() {
    this.render();
    this._insertData();
  }

  render() {
    this.innerHTML = `
      <section class="w-11/12 lg:w-3/5 mt-8 mb-20 md:mb-24 m-auto">
        <div class="section-title-container">
          <h2 class="section-title" tabindex="0">
            Tersimpan <span id="total-favorite-ayah"></span>
          </h2>
          <p class="section-subtitle" tabindex="0">
            Simpan ayat dan temukan disini
          </p>
        </div>
        <article id="container-favorite"></article>
      </section>
    `;
  }

  async _insertData() {
    this.innerHTML += createLoadingTemplate();
    const favorites = await AppIdb.getAll(CONFIG.OBJECT_STORE_AYAHS);
    const containerFavorite = this.querySelector('#container-favorite');
    const totalFavoriteAyah = this.querySelector('#total-favorite-ayah');
    if (favorites.length > 0) {
      this._insertDataFavorite(favorites, containerFavorite);
      this._insertDataTotalAyah(favorites, totalFavoriteAyah);
    } else {
      totalFavoriteAyah.innerHTML = '';
      containerFavorite.innerHTML = createContentEmptyTemplate();
    }
    this.lastElementChild.remove();
  }

  // eslint-disable-next-line class-methods-use-this
  _insertDataTotalAyah(favorites, totalFavoriteAyah) {
    const totalItem = favorites.length;
    totalFavoriteAyah.innerHTML = `(${totalItem} Ayat)`;
  }

  _insertDataFavorite(favorites, containerFavorite) {
    for (let index = 0; index < favorites.length; index++) {
      const favorite = favorites[index];
      favorite.number.inSurah = index + 1;
      containerFavorite.innerHTML += createAyahTemplate(favorite);
      const ayahContainer = containerFavorite.children[index];
      this._createAyahTitle({ ayahContainer, favorite });
    }
    const surah = { data: { ayahs: favorites } };
    this._handlerAyahTool(surah);
  }

  // eslint-disable-next-line class-methods-use-this
  _createAyahTitle({ ayahContainer, favorite }) {
    const {
      surahNumber, surahName, surahTranslation, surahRevelation,
    } = favorite;
    const linkTitleAyahNode = document.createElement('a');
    const titleAyahNode = document.createElement('h3');
    const titleAyah = `${surahNumber}. ${surahName} (${surahTranslation}) - ${surahRevelation}`;
    const titleAyahText = document.createTextNode(titleAyah);
    titleAyahNode.appendChild(titleAyahText);
    titleAyahNode.classList.add('text-center', 'text-lg', 'mb-2', 'underline');
    linkTitleAyahNode.setAttribute('href', `#/surah/${surahNumber}`);
    linkTitleAyahNode.append(titleAyahNode);
    ayahContainer.insertBefore(linkTitleAyahNode, ayahContainer.firstChild);
  }

  _handlerAyahTool(surah) {
    const btnTafsirAyah = this.querySelectorAll('#btn-tafsir-ayah');
    const btnPlayAyah = this.querySelectorAll('#btn-play-ayah');
    const btnBookmarkAyah = this.querySelectorAll('#btn-bookmark-ayah');
    const btnFavoriteAyah = this.querySelectorAll('#btn-favorite-ayah');
    const btnCopyAyah = this.querySelectorAll('#btn-copy-ayah');
    AyahToolInitiator.init({
      surah, btnTafsirAyah, btnPlayAyah, btnBookmarkAyah, btnFavoriteAyah, btnCopyAyah,
    });
  }
}

customElements.define('favorite-page', Favorite);
const favorite = '<favorite-page></favorite-page>';
export default favorite;
